import { CheckCircle2, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

function formatEur(n) {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency', currency: 'EUR', minimumFractionDigits: 2,
  }).format(Number(n ?? 0));
}

/**
 * CreateInvoiceResult — shown after a CREATE_INVOICE action executes.
 *
 * Displays the created invoice number, client, total, and a deeplink
 * button to open the invoice in the split-view drawer.
 *
 * Props: result { type, id, numero, cliente, total, estado }
 */
export default function CreateInvoiceResult({ result }) {
  if (!result) return null;

  return (
    <div className="rounded-xl border border-success/30 bg-success/10 px-3 py-2.5 flex items-center justify-between gap-3 my-1 max-w-sm">
      <div className="flex items-center gap-2 min-w-0">
        <CheckCircle2 className="w-4 h-4 text-success shrink-0" />
        <div className="min-w-0">
          <p className="text-xs font-semibold text-foreground truncate">
            {result.numero} · {result.cliente}
          </p>
          <p className="text-[10px] text-muted-foreground">
            {formatEur(result.total)} · borrador creado
          </p>
        </div>
      </div>
      {result.id && (
        <Link to={`/facturas?invoice=${result.id}`}>
          <Button size="sm" variant="outline"
            className="h-7 text-[11px] shrink-0 gap-1 border-success/30 text-success hover:bg-success/10">
            Ver
            <ExternalLink className="w-3 h-3" />
          </Button>
        </Link>
      )}
    </div>
  );
}
